import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";

interface filterProps {
    onFilter : (numbers : number[]) => void;
}

const StatusFilter : React.FC<filterProps> = ({onFilter}) => {
    const defaultStatusFilter = [
            { id: 1, selected : true, status: "On Initial Stage" },
            { id: 2, selected : true, status: "On Mid Stage" },
            { id: 3, selected : true, status: "On Final Stage" },
            { id: 4, selected : true, status: "For Job Offer" },
            { id: 5, selected : true, status: "Offer Accepted" },
            { id: 6, selected : true, status: "Onboarded" },
            { id: 7, selected : true, status: "Withdraw" },
            { id: 8, selected : true, status: "Reneged" },
            { id: 9, selected : true, status: "Source Tagging" },
            { id: 10, selected : true, status : "Closed Role" },
            { id: 11, selected : true, status : "Offer Rejected" },
            { id: 0, selected : true, status: "Failed" },
        ]
    const savedStatusFilter = localStorage.getItem('status_filter');
    const parsedStatusFilter = savedStatusFilter ? JSON.parse(savedStatusFilter) : defaultStatusFilter;
    const [showFilter, setShowFilter] = useState<boolean>(false);
    const [statusArray, setStatusArray] = useState<{ id: number; selected : boolean; status: string }[]>(
        defaultStatusFilter.length === parsedStatusFilter.length ? parsedStatusFilter : defaultStatusFilter
    );
    const divFloatCard = useRef<HTMLDivElement | null>(null);

    const handleSelectStatus = (id : number | null) => {
        if(id === null){
            const all_selected = statusArray.every(item => item.selected === true);
            setStatusArray(statusArray.map(stat => ({...stat, selected : all_selected ? false : true})));
        }else{
            setStatusArray(statusArray.map(stat =>  id === stat.id ? ({...stat, selected : stat.selected ? false : true}) : stat));
        }
    }

    const handleClickOutside = (event: MouseEvent) => {
        if (
            !(divFloatCard.current?.contains(event.target as Node))
        ) {
            setShowFilter(false);
        }
    };

    useEffect(()=>{
        let numbers : number[] = [];
        for(const obj of statusArray ){
            if(obj.selected){
                numbers.push(obj.id);
            }
        }
        onFilter(numbers);
        localStorage.setItem('status_filter', JSON.stringify(statusArray));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[statusArray])

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return(
        <div className="relative">
            <div 
                onClick={()=>setShowFilter(showFilter ? false : true)}
                className="flex justify-center gap-2 text-md uppercase border px-2 py-1 shadow bg-gray-100 cursor-pointer hover:bg-gray-200">
                <div>
                    <FontAwesomeIcon  icon={faSquareCheck} className="text-gray-500" />
                </div>
                <button>
                    Filter Status
                </button>
            </div>
            {showFilter && (
                <div ref={divFloatCard} className=" flex flex-col gap-2 absolute top-12 end-8 bg-white border p-2 z-50 shadow-lg max-h-[46rem] overflow-y-auto min-w-44">
                    <div className="flex gap-2 items-center ms-4">
                        <div>
                            <input type="checkbox" onChange={()=>handleSelectStatus(null)} checked={statusArray.every(item => item.selected === true)} className="cursor-pointer" />
                        </div>
                        <div>
                            <h2>Select All</h2>
                        </div>
                    </div>
                    {statusArray.map(stat => (
                        <div className="flex gap-2 items-center ms-4">
                            <div>
                                <input type="checkbox" onChange={()=>handleSelectStatus(stat.id)} checked={stat.selected} className="cursor-pointer" />
                            </div>
                            <div>
                                <h2>{stat.status}</h2>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default StatusFilter;